<div class="row" fxLayout="row">
  <fs-rating [ngModel]="rating" [selectable]="true" [showValue]="true"></fs-rating>
  <div fxFlex></div>
  <b>No tasting room</b>
</div>
